<template>
  <div class="add-page">
    <van-nav-bar title="添加监护人" left-text="返回" left-arrow @click-left="$router.go('-1')" />
    <div class="ap-conts">
      <div class="ap-lable">手机号：</div>
      <div class="box-2 flex-row" style="justify-content: center; align-items: center">
        <input
          placeholder="请输入"
          v-model="phone"
          type="number"
          class="device-input"
          @input="getInput"
        />
        <div class="tip">
          <span class="tip-span" v-if="showphone">请输入正确的11位手机号</span>
        </div>
      </div>

      <div class="ap-lable">短信验证码：</div>
      <div class="boxflex-row">
        <input
          v-model="phonecode"
          maxlength="6"
          class="phoneInput"
          placeholder="输入验证码"
          type="number"
        />
        <van-button :disabled="disabled" @click="getCode" class="input_code">
          {{ codeMsg }}
        </van-button>
      </div>
      <div class="tip">
        <span class="tip-span" v-if="showphonecode">短信验证码不正确</span>
      </div>

      <div class="ap-lable">监护人关系：</div>
      <div class="box-2 flex-row">
        <van-field
          v-model="relation"
          is-link
          readonly
          label=""
          placeholder="请选择监护人关系"
          placeholder-text-color="#616161"
          @click="showRelation = true"
          style="border: 1px solid #6ebeff; border-radius: 10px; padding-left: 5px"
        />
        <van-popup v-model="showRelation" position="bottom">
          <van-cascader
            v-model="cascaderValue"
            title="监护人关系"
            :options="relationList"
            @close="showRelation = false"
            @finish="onRelationFinish"
            class="custom-cascader"
          />
        </van-popup>
      </div>
      <div class="tip">
        <span class="tip-span" v-if="showrelation">您还未选择与学生的关系</span>
      </div>
    </div>

    <div style="margin: 50px 12px">
      <van-button block type="info" native-type="submit" @click="bindDevice">确认</van-button>
    </div>
  </div>
</template>

<script>
import { Button, Toast, NavBar, Cascader, Field } from 'vant'

export default {
  data() {
    return {
      codeMsg: '获取验证码',
      cascaderValue: '',
      showRelation: false,
      relation: '',
      phone: '',
      phonecode: '',
      disabled: false,
      showphone: false,
      showphonecode: false,
      showrelation: false,
      codeNum: 90,
      relationList: [
        {
          text: '爸爸',
          value: '爸爸',
        },
        {
          text: '妈妈',
          value: '妈妈',
        },
        {
          text: '爷爷',
          value: '爷爷',
        },
        {
          text: '奶奶',
          value: '奶奶',
        },
        {
          text: '外公',
          value: '外公',
        },
        {
          text: '外婆',
          value: '外婆',
        },
        {
          text: '姥姥',
          value: '姥姥',
        },
        {
          text: '姥爷',
          value: '姥爷',
        },
        {
          text: '姑姑',
          value: '姑姑',
        },
        {
          text: '姑父',
          value: '姑父',
        },
        {
          text: '大伯',
          value: '大伯',
        },
        {
          text: '伯母',
          value: '伯母',
        },
        {
          text: '叔叔',
          value: '叔叔',
        },
        {
          text: '阿姨',
          value: '阿姨',
        },
        {
          text: '哥哥',
          value: '哥哥',
        },
        {
          text: '姐姐',
          value: '姐姐',
        },
        {
          text: '其他',
          value: '其他',
        },
      ],
      rge: /^((13\d)|(14[5,7,9])|(15[0-3,5-9])|(166)|(17[0,1,3,5,7,8])|(18[0-9])|(19[8,9]))\d{8}/,
    }
  },
  created() {
    console.log(this.$route.query)
    // this.$http.json_post(this.$api.login.testwxmain, {}).then((res) => {
    //   console.log('data', res)
    // })
  },

  methods: {
    bindDevice() {
      if (this.phone === '' || !this.rge.test(this.phone)) {
        return (this.showphone = true)
      } else {
        this.showphone = false
      }
      if (this.phonecode === '') {
        return (this.showphonecode = true)
      } else {
        this.showphonecode = false
      }

      if (this.relation === '') {
        return (this.showrelation = true)
      } else {
        this.showrelation = false
      }

      this.$http
        .json_post(this.$api.login.verifysmscode, {
          phone: this.phone,
          Smscode: this.phonecode,
        })
        .then((res) => {
          if (res.code === 0) {
            this.$http
              .json_post(this.$api.login.addguardian, {
                phone: this.phone,
                studentId: this.$route.query.studentId,
                relation: this.relation,
              })
              .then((data) => {
                if (data.code === 0) {
                  this.$router.push({name:"my",query:{studentid:this.$route.query.studentId}});
                } else {
                  Toast.fail(data.msg)
                }
              })
          } else {
            this.showphonecode = true
            Toast.fail(res.msg)
          }
        })
    },
    onRelationFinish(values) {
      console.log(values)
      this.relation = values.selectedOptions[0].text

      this.showRelation = false
    },
    getCode() {
      if (this.phone === '' || !this.rge.test(this.phone)) {
        return (this.showphone = true)
      } else {
        this.showphone = false
      }

      // 禁用按钮
      this.disabled = true
      this.$http
        .json_post(this.$api.login.getsmscode, {
          Phone: this.phone,
        })
        .then((data) => {
          console.log('data', data)
          if (data.code === 0) {
            this.codeMsg = `重新发送(${this.codeNum})`
            // 倒计时
            var timer = setInterval(() => {
              --this.codeNum
              this.codeMsg = `重新发送(${this.codeNum})`
            }, 1000)
            // 判断什么时候停止定时器
            setInterval(() => {
              clearInterval(timer)
              this.codeNum = 90
              this.disabled = false
              this.codeMsg = '获取短信验证码'
            }, 90000)
          } else {
            Toast.fail(data.msg)
            this.disabled = false
            this.codeMsg = '获取短信验证码'
          }
        })
    },

    getInput(e) {
      setTimeout(() => {
        let that = this
        if (that.rge.test(that.phone)) {
          that.showphone = false
        } else {
          that.showphone = true
        }
      }, 300)
    },
  },

  components: {
    'van-button': Button,
    'van-nav-bar': NavBar,
    'van-cascader': Cascader,
    'van-field': Field,
  },
}
</script>

<style lang="scss" scoped>
.add-page {
  font-family: PingFangSC, PingFang SC;

  .boxflex-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
  }

  .ap-conts {
    margin: 22px 12px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 17px 8px 8px 10px;
    .ap-lable {
      font-weight: 600;
      font-size: 16px;
      color: #2c2d32;
      line-height: 22px;
      margin-bottom: 5px;
      margin-top: 10px;
    }
    .device-input {
      background: #ffffff;
      box-shadow: 0rpx 4px 10px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      border: 1px solid #6ebeff;
      width: calc(100% - 8px);
      height: 40px;
    }
  }
  .tip {
    font-weight: 600;
    font-size: 10px;
    color: #616161;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tip-span {
      color: #fe5334;
    }
  }

  .phoneInput {
    height: 40px;
    border: 1px solid #6ebeff;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    width: 90%;
    border-right: none;
  }
  .input_code {
    position: absolute;
    height: 45px;
    width: 150px;
    background: #6ebeff;
    border-radius: 10px;
    right: 0px;
    color: #ffffff;
  }
}
.custom-cascader .van-cascader__option span {
  font-size: 30px !important;
}
</style>
